import ContentScreen from './content-screen';
import './content-screen.scss';

export default ContentScreen;
